import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const IndigenousReservation = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <Donut
            title={'Residência em Reserva Indígena'}
            subtitles={chartData?.indigenousReservation?.map(
                (item) => item.description
            )}
            chartData={chartData?.indigenousReservation || []}
            colors={
                defaultColors.slice(0, chartData?.indigenousReservation?.length) ||
                []
            }
            height={400}
        />
    );
};
